import React from "react";
import DashboardLayout from "@/components/DashboardLayout";
import { SCHOOL_NAV } from "./SchoolDashboard";
import { useAuth } from "@/context/AuthContext";

export default function Settings() {
  const { user } = useAuth();
  return (
    <DashboardLayout nav={SCHOOL_NAV} title="Settings">
      <div className="rounded-2xl border border-slate-200 bg-white p-6 max-w-2xl">
        <h2 className="font-heading font-semibold text-brand-navy text-lg">Your account</h2>
        <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
          <Row k="Name" v={user?.name} />
          <Row k="Email" v={user?.email} />
          <Row k="Role" v={user?.role?.replace('_',' ')} />
          <Row k="Approval role" v={user?.approval_role || '—'} />
        </div>
      </div>
      <div className="mt-6 rounded-2xl border border-slate-200 bg-white p-6 max-w-2xl">
        <h2 className="font-heading font-semibold text-brand-navy text-lg">Preferences</h2>
        <p className="text-slate-500 text-sm mt-2">
          Advanced preferences — notification channels, default delivery address, budget alerts —
          coming in the next release.
        </p>
      </div>
    </DashboardLayout>
  );
}

function Row({ k, v }) {
  return (
    <div>
      <div className="text-xs uppercase tracking-wide text-slate-500">{k}</div>
      <div className="mt-1 font-semibold text-brand-navy">{v || '—'}</div>
    </div>
  );
}
